module.exports = __webpack_public_path__ + "img/icon_material_cumulative_sjyl.45ae067e.webp";